import React, { useState, useEffect, useCallback } from "react";
import { Modal, Button } from "react-bootstrap";
import { createModal } from "react-modal-promise";
import SelectBox from "../../../../components/SelectBox";
import { isFieldDisabled } from "../../../../utils/validators";
import { useAxiosWithAuthorization } from "../../../../utils/api";
import useAppContext from "../../../../utils/Reducers";
import axios from "axios";
import moment from "moment";

const Grade = ({ inspData, onClose }) => {
  //차량 검색 URL
  //공통코드 검색 URL

  const {
    store: { userInfo },
  } = useAppContext();

  const SEARCH_CODE_URL = "/common/code/searchDetailCode.do";

  //추가, 수정일때 항목의 disabled 결정
  const disabledFields = {
    created: [""],
    updated: ["systemCd"],
  };

  const initValue = {
    status: "C",
    systemCd: "",
    inspNo: "",
    inspDt: "",
    plantCd1: "",
    plantCd: "",
    transCd: "",
    vhclNo: "",
    vhclType: "",
    itemCd: "",
    vndrCd: "",
    vndrNm: "",
    loadAreaCd: "",
    loadAreaNm: "",
    scrapAreaCd: "",
    scrapAreaNm: "",
    magnet: "",
    dcsnItemCd: "",
    subItemCd1: "",
    subItemPrdCd1: "",
    subItemRate1: "",
    subItemCd2: "",
    subItemPrdCd2: "",
    subItemRate2: "",
    subItemCd3: "",
    subItemPrdCd3: "",
    subItemRate3: "",
    outageCd: "",
    outageWght: "",
    outageRsn: "",
    returnCd: "",
    returnWght: "",
    returnRsn: "",
    dprctCd: "",
    dprctRate: "",
    scalNo: "",
    tmsOdrNo: "",
    workerId: "",
    inspCd: "R",
    rmks: "",
    inptDt: "",
    totalWeight: "",
    dcsnItemScoreCd: "",
    dcsnDesc: "",
  };

  const initItem = {
    systemCd: inspData.systemCd,
    inspNo: inspData.wssId,
    wssId: inspData.wssId,
    inspDt: "",
    plantCd1: inspData.plantCd1,
    plantCd: inspData.plantCd,
    transCd: inspData.transCd,
    transCdNm: inspData.transCdNm,
    vhclNo: inspData.vhclNo,
    vhclType: inspData.vhclType,
    totalWeight: inspData.totalWeight,
    itemCd: inspData.itemCd,
    itemNm: inspData.itemNm,
    vndrCd: inspData.vndrCd,
    vndrNm: inspData.vndrNm,
    rvndrCd: inspData.rvndrCd,
    rvndrNm: inspData.rvndrNm,
    loadAreaCd: inspData.loadAreaCd,
    loadAreaNm: inspData.loadAreaNm,
    scrapAreaCd: inspData.scrapAreaCd,
    scrapAreaNm: "",
    magnet: "",
    dcsnItemCd: "",
    subItemCd1: "",
    subItemPrdCd1: "",
    subItemRate1: "",
    subItemCd2: "",
    subItemPrdCd2: "",
    subItemRate2: "",
    subItemCd3: "",
    subItemPrdCd3: "",
    subItemRate3: "",
    outageCd: "",
    outageWght: "",
    outageRsn: "",
    returnCd: "",
    returnWght: "",
    returnRsn: "",
    dprctCd: "",
    dprctRate: "",
    scalNo: "",
    tmsOdrNo: inspData.tmsOdrNo,
    workerId: "",
    inspCd: "R",
    rmks: "",
    inptDt: inspData.inptDt,
    returnCnt: inspData.returnCnt,
    dcsnItemScoreCd: "",
    dcsnDesc: "",
  };

  const [state, setState] = useState("created");

  const [fieldValues, setFieldValues] = useState(initItem);

  useEffect(() => {
    console.log(inspData.dcsnItemCd);
    console.log(inspData);
    if (inspData.dcsnItemCd !== "") setFieldValues(inspData);
  }, []);

  const SEARCH_SCORE_GRADE_URL = "/inspection/video/searchScoreGrade.do";
  const fetchScoreGrade = async () => {

    const rate1 = fieldValues.subItemCd1 ? parseInt(fieldValues.subItemRate1) || 0 : 0;
    const rate2 = fieldValues.subItemCd2 ? parseInt(fieldValues.subItemRate2) || 0 : 0;
    const rate3 = fieldValues.subItemCd3 ? parseInt(fieldValues.subItemRate3) || 0 : 0;

    let lDcsnItemCd= '';
    let lDcsnItemScoreCd= '';
    let lDcsnDesc= '';


    const total = rate1 + rate2 + rate3;

/*    setFieldValues({
      ...fieldValues,
      dcsnItemCd: '',
      dcsnDesc: ''
    });*/

    setFieldValues(prev => ({
      ...prev,
      dcsnItemCd: '',
      dcsnItemScoreCd: '',
      dcsnDesc: ''
    }));



    if (total === 100) {

      try {
        const {
          data: {data},
        } = await fetchData({
          url: SEARCH_SCORE_GRADE_URL,
          params: {
            systemCd : fieldValues.systemCd,
            subItemCd1 : fieldValues.subItemCd1,
            subItemCd2 : fieldValues.subItemCd2,
            subItemCd3 : fieldValues.subItemCd3,
            subItemRate1 : rate1,
            subItemRate2 : rate2,
            subItemRate3 : rate3
          },
          method: "POST",
        });
        console.log("Fetch result:", data);

        if (data && data.length > 0 && data[0].detlCd) {
          // If data exists and is valid, set the dcsnItemCd

          console.log(`${inspData.dcsnItemCd} ( 스코어:${data[0].score} )`);

          lDcsnItemCd= data[0].detlCd;
          lDcsnItemScoreCd= data[0].detlCd;
          lDcsnDesc= `${data[0].score} ${inspData.dcsnItemCd == null || inspData.dcsnItemCd === "" ? '' : ', 검수입력등급: ' + inspData.dcsnItemNm}`;

/*          setFieldValues((prevValues) => ({
            ...prevValues,
            dcsnItemCd: data[0].detlCd, // Set dcsnItemCd to the fetched value
            dcsnItemScoreCd: data[0].detlCd, // Set dcsnItemCd to the fetched value
            dcsnDesc: `${data[0].score}`,
          }));*/
        } else {
          // If no valid data, reset dcsnItemCd
/*          setFieldValues((prevValues) => ({
            ...prevValues,
            dcsnItemCd: '', // Reset dcsnItemCd to an empty string
            dcsnItemScoreCd: '', // Reset dcsnItemCd to an empty string
            dcsnDesc: '', // Reset dcsnItemCd to an empty string
          }));*/

          lDcsnItemCd= '';
          lDcsnItemScoreCd= '';
          lDcsnDesc= `${inspData.dcsnItemCd == null || inspData.dcsnItemCd === "" ? '' : '검수입력등급: ' + inspData.dcsnItemNm}`;
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }else{
      lDcsnItemCd= '';
      lDcsnItemScoreCd= '';
      lDcsnDesc= `${inspData.dcsnItemCd == null || inspData.dcsnItemCd === "" ? '' : '검수입력등급: ' + inspData.dcsnItemNm}`;
/*      setFieldValues({
        ...fieldValues,
        dcsnItemCd: '', // Reset dcsnItemCd to an empty string
        dcsnItemScoreCd: '', // Reset dcsnItemCd to an empty string
        dcsnDesc: '', // Reset dcsnItemCd to an empty string
      });*/
    }

    console.log(lDcsnItemCd)

/*    setFieldValues({
      ...fieldValues,
      dcsnItemCd: lDcsnItemCd,
      dcsnItemScoreCd: lDcsnItemScoreCd,
      dcsnDesc: lDcsnDesc
    });*/

    setFieldValues(prev => ({
      ...prev,
      dcsnItemCd: lDcsnItemCd,
      dcsnItemScoreCd: lDcsnItemScoreCd,
      dcsnDesc: lDcsnDesc
    }));


  }

  useEffect(() => {
      fetchScoreGrade();
  }, [fieldValues.subItemRate1,
            fieldValues.subItemRate2,
            fieldValues.subItemRate3,
            fieldValues.subItemCd1,
            fieldValues.subItemCd2,
            fieldValues.subItemCd3
          ]);


  const SAVE_INSPECTION_PROGRESS_URL =
    "/inspection/video/saveInspectionProgress.do";
  const [, fetchData] = useAxiosWithAuthorization(
    {
      url: SEARCH_CODE_URL,
    },
    { manual: true }
  );
  const handleChangeField = useCallback((event) => {
    //console.log(fieldValues);

    const { name, value } = event.target;
    if (name === "scrapAreaCd") {
      var scrapAreaNm = event.target.options[event.target.selectedIndex].text;
      setFieldValues({
        ...fieldValues,
        [name]: value,
        ["scrapAreaNm"]: scrapAreaNm,
      });
    } else {
      setFieldValues({
        ...fieldValues,
        [name]: value,
      });
    }
  });

  const handleMasterSave = async () => {
    if (window.confirm("검수데이터를 저장하시겠습니까?")) {
      let totalRate =
        (fieldValues.subItemRate1 === "" ||
        fieldValues.subItemRate1 === null ||
        fieldValues.subItemRate1 === undefined
          ? 0
          : parseInt(fieldValues.subItemRate1)) +
        (fieldValues.subItemRate2 === "" ||
        fieldValues.subItemRate2 === null ||
        fieldValues.subItemRate2 === undefined
          ? 0
          : parseInt(fieldValues.subItemRate2)) +
        (fieldValues.subItemRate3 === "" ||
        fieldValues.subItemRate3 === null ||
        fieldValues.subItemRate3 === undefined
          ? 0
          : parseInt(fieldValues.subItemRate3));

      if (
        fieldValues.dcsnItemCd === "" ||
        fieldValues.dcsnItemCd === null ||
        fieldValues.dcsnItemCd === undefined
      ) {
        alert("검수등급을 선택하지 않았습니다. ");
        return;
      }
      if (
        fieldValues.scrapAreaCd === "" ||
        fieldValues.scrapAreaCd === null ||
        fieldValues.scrapAreaCd === undefined
      ) {
        alert("하차지를 선택하지 않았습니다. ");
        return;
      }

      if (totalRate !== 100) {
        alert("세부품목비율 합계가 100%가 아닙니다. 다시 입력하세요..");
        return;
      }

      let total11 =
        fieldValues.subItemCd1 === "" ||
        fieldValues.subItemCd1 === null ||
        fieldValues.subItemCd1 === undefined
          ? 0
          : parseInt(fieldValues.subItemCd1);
      let total12 =
        fieldValues.subItemPrdCd1 === "" ||
        fieldValues.subItemPrdCd1 === null ||
        fieldValues.subItemPrdCd1 === undefined
          ? 0
          : parseInt(fieldValues.subItemPrdCd1);
      let total13 =
        fieldValues.subItemRate1 === "" ||
        fieldValues.subItemRate1 === null ||
        fieldValues.subItemRate1 === undefined
          ? 0
          : parseInt(fieldValues.subItemRate1);
      //console.log();

      if (total11 === 0 || total12 === 0 || total13 === 0) {
        alert("세부등급1, 세부품목1, 세부비율1은 필수항목입니다. ");
        return;
      }

      if (
        (total11 === 0 && total12 === 0 && total13 === 0) ||
        (total11 > 0 && total12 > 0 && total13 > 0)
      ) {
      } else {
        alert(
          "세부등급1, 세부품목1, 세부비율1 중 선택하지 않은 항목이 있습니다. "
        );
        return;
      }

      let total21 =
        fieldValues.subItemCd2 === "" ||
        fieldValues.subItemCd2 === null ||
        fieldValues.subItemCd2 === undefined
          ? 0
          : parseInt(fieldValues.subItemCd2);
      let total22 =
        fieldValues.subItemPrdCd2 === "" ||
        fieldValues.subItemPrdCd2 === null ||
        fieldValues.subItemPrdCd2 === undefined
          ? 0
          : parseInt(fieldValues.subItemPrdCd2);
      let total23 =
        fieldValues.subItemRate2 === "" ||
        fieldValues.subItemRate2 === null ||
        fieldValues.subItemRate2 === undefined
          ? 0
          : parseInt(fieldValues.subItemRate2);
      //console.log();
      if (
        (total21 === 0 && total22 === 0 && total23 === 0) ||
        (total21 > 0 && total22 > 0 && total23 > 0)
      ) {
      } else {
        alert(
          "세부등급2, 세부품목2, 세부비율2 중 선택하지 않은 항목이 있습니다. "
        );
        return;
      }

      let total31 =
        fieldValues.subItemCd3 === "" ||
        fieldValues.subItemCd3 === null ||
        fieldValues.subItemCd3 === undefined
          ? 0
          : parseInt(fieldValues.subItemCd3);
      let total32 =
        fieldValues.subItemPrdCd3 === "" ||
        fieldValues.subItemPrdCd3 === null ||
        fieldValues.subItemPrdCd3 === undefined
          ? 0
          : parseInt(fieldValues.subItemPrdCd3);
      let total33 =
        fieldValues.subItemRate3 === "" ||
        fieldValues.subItemRate3 === null ||
        fieldValues.subItemRate3 === undefined
          ? 0
          : parseInt(fieldValues.subItemRate3);

      if (
        (total31 === 0 && total32 === 0 && total33 === 0) ||
        (total31 > 0 && total32 > 0 && total33 > 0)
      ) {
      } else {
        alert(
          "세부등급3, 세부품목3, 세부비율3 중 선택하지 않은 항목이 있습니다. "
        );
        return;
      }

      if (
        fieldValues.outageWght === "" ||
        fieldValues.outageWght === null ||
        fieldValues.outageWght === undefined
      ) {
      } else {
        if (
          fieldValues.outageRsn === "" ||
          fieldValues.outageRsn === null ||
          fieldValues.outageRsn === undefined
        ) {
          alert("감량사유를 선택하지 않았습니다. ");
          return;
        }
      }

      if (
        fieldValues.returnCd === "" ||
        fieldValues.returnCd === null ||
        fieldValues.returnCd === undefined
      ) {
      } else {
        if (
          fieldValues.returnRsn === "" ||
          fieldValues.returnRsn === null ||
          fieldValues.returnRsn === undefined
        ) {
          alert("반품사유를 선택하지 않았습니다. ");
          return;
        }
      }
      //console.log(fieldValues);
      if (fieldValues.systemCd === "DH") {
        if (
          fieldValues.dprctRate === "" ||
          fieldValues.dprctRate === null ||
          fieldValues.dprctRate === undefined
        ) {
        } else {
          if (
            fieldValues.dprctCd === "" ||
            fieldValues.dprctCd === null ||
            fieldValues.dprctCd === undefined
          ) {
            alert("감가내역를 선택하지 않았습니다. ");
            return;
          }
        }
      }

      let values = fieldValues;
      if (inspData.inspNo === "" || inspData.inspNo === null) {
        values.status = "C";
        values.inspNo = inspData.wssId;
        values.transStatusCd = "I";
      } else {
        values.status = "U";
      }
      //console.log(values);
      const {
        data: { data },
      } = await fetchData({
        url: SAVE_INSPECTION_PROGRESS_URL,
        data: values,
        method: "POST",
      });
      alert(`[ ${values.inspNo} ]데이터가 저장되었습니다. `);
      setFieldValues(initValue);
      onClose();
    }
  };

  const AI_LOGIN_URL = "http://223.130.130.35/api/userLogin/login";
  const AI_INSPECTION_URL = "http://223.130.130.35/api/inspct/start_inspct";
  const handleInspectionAI = async () => {
    const {
      accessToken: { accessToken },
    } = await axios({
      method: "POST",
      url: AI_LOGIN_URL,
      data: {
        emplyrId: "test",
        pwd: "1234",
      },
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers": "*",
        "Access-Control-Allow-Credentials": "true",
      },
    }).catch(function (error) {
      console.log(error);
      alert("AI 검수 연결이 안됩니다. ");
      return;
    });

    if (accessToken !== "") {
      const {
        data: { data },
      } = await fetchData({
        url: AI_INSPECTION_URL,
        data: {
          cmpny_cd:
            fieldValues.plantCd === "1200" && fieldValues.plantCd === "1100"
              ? "DHS"
              : "YK",
          scrap_zone_cd: fieldValues.scrapAreaCd,
          vhcle_no: fieldValues.vhclNo,
          wt_mesure_time: moment().format("YYYY-MM-DD HH:mm:ss"),
          inspct_refer_esntl_key: fieldValues.tmsOdrNo,
        },
        method: "POST",
        headers: {
          Authorization: accessToken,
        },
      });
    } else {
      alert("입차호출 에러로 다시 입차호출버튼을 클릭해주시기 바랍니다.  ");
    }
  };

  return (
    <>
      <ul className="mlist">
        <li className="head">
          <div>사전등급</div>
        </li>
        <li>
          <div>{fieldValues.transCdNm}</div>
        </li>
        <li>
          <div>{fieldValues.itemNm}</div>
        </li>

        <li className="head">
          <div>차량정보</div>
        </li>
        <li>
          <div>{fieldValues.vhclNo}</div>
        </li>
        <li>
          <div>
            <SelectBox
              mastCd="VHCL_TYPE"
              id="vhclType"
              name="vhclType"
              topSelected="선택"
              disabled={isFieldDisabled(state, "vhclType", disabledFields)}
              onChange={handleChangeField}
              value={fieldValues.vhclType}
              className="ip2"
            />
          </div>
        </li>

        <li className="head">
          <div>업체정보</div>
        </li>
        <li>
          <div>{fieldValues.vndrNm}</div>
        </li>
        <li>
          <div>{fieldValues.rvndrNm}</div>
        </li>

        <li className="head">
          <div>하차지</div>
        </li>
        <li className="fullsc">
          <div>
            <SelectBox
              mastCd="SCRAP_AREA_CD"
              id="scrapAreaCd"
              name="scrapAreaCd"
              topSelected="선택"
              disabled={isFieldDisabled(state, "scrapAreaCd", disabledFields)}
              attr1={fieldValues.plantCd}
              attr
              onChange={handleChangeField}
              value={fieldValues.scrapAreaCd}
              className="ip2"
            />
          </div>
        </li>

        <li className="head">
          <div>검수등급</div>
        </li>
        <li className="fullsc">
          <div>
            <SelectBox
              mastCd="ITEM_CD"
              id="dcsnItemCd"
              name="dcsnItemCd"
              topSelected="선택"
              disabled={isFieldDisabled(state, "dcsnItemCd", disabledFields)}
              onChange={handleChangeField}
              value={fieldValues.dcsnItemCd}
              className="ip2"
            />
          </div>
        </li>

        <li className="head">
          <div>스코어</div>
        </li>
        <li className="fullsc">
          <div>
            <input
              type="text"
              id="dcsnDescText"
              name="dcsnDescText"
              value={fieldValues.dcsnDesc}
              disabled={true}
              className="ip2"
              />
          </div>
        </li>
      </ul>
      <ul className="mlist quad">
        <li className="fullhead">
          <div>등급 별 품목/비율 입력</div>
        </li>

        <li className="head">
          <div>등급 01</div>
        </li>
        <li>
          <div>
            <SelectBox
              mastCd="ITEM_CD"
              id="subItemCd1"
              name="subItemCd1"
              disabled={isFieldDisabled(state, "subItemCd1", disabledFields)}
              topSelected="선택"
              onChange={handleChangeField}
              value={fieldValues.subItemCd1}
              className="ip2"
            />
          </div>
        </li>
        <li>
          <div>
            <SelectBox
              mastCd="ITEM_PRD_CD"
              id="subItemPrdCd1"
              name="subItemPrdCd1"
              disabled={isFieldDisabled(state, "subItemPrdCd1", disabledFields)}
              topSelected="선택"
              onChange={handleChangeField}
              attr1={fieldValues.subItemCd1}
              value={fieldValues.subItemPrdCd1}
              className="ip2"
            />
          </div>
        </li>
        <li>
          <div>
            <SelectBox
              mastCd="ITEM_RATE"
              id="subItemRate1"
              name="subItemRate1"
              disabled={isFieldDisabled(state, "subItemRate1", disabledFields)}
              topSelected="선택"
              onChange={handleChangeField}
              value={fieldValues.subItemRate1}
              className="ip2"
            />
          </div>
        </li>

        <li className="head">
          <div>등급 02</div>
        </li>
        <li>
          <div>
            <SelectBox
              mastCd="ITEM_CD"
              id="subItemCd2"
              name="subItemCd2"
              disabled={isFieldDisabled(state, "subItemCd2", disabledFields)}
              topSelected="선택"
              onChange={handleChangeField}
              value={fieldValues.subItemCd2}
              className="ip2"
            />
          </div>
        </li>
        <li>
          <div>
            <SelectBox
              mastCd="ITEM_PRD_CD"
              id="subItemPrdCd2"
              name="subItemPrdCd2"
              disabled={isFieldDisabled(state, "subItemPrdCd2", disabledFields)}
              topSelected="선택"
              onChange={handleChangeField}
              attr1={fieldValues.subItemCd2}
              value={fieldValues.subItemPrdCd2}
              className="ip2"
            />
          </div>
        </li>
        <li>
          <div>
            <SelectBox
              mastCd="ITEM_RATE"
              id="subItemRate2"
              name="subItemRate2"
              disabled={isFieldDisabled(state, "subItemRate2", disabledFields)}
              topSelected="선택"
              onChange={handleChangeField}
              value={fieldValues.subItemRate2}
              className="ip2"
            />
          </div>
        </li>

        <li className="head">
          <div>등급 03</div>
        </li>
        <li>
          <div>
            <SelectBox
              mastCd="ITEM_CD"
              id="subItemCd3"
              name="subItemCd3"
              disabled={isFieldDisabled(state, "subItemCd3", disabledFields)}
              topSelected="선택"
              onChange={handleChangeField}
              value={fieldValues.subItemCd3}
              className="ip2"
            />
          </div>
        </li>
        <li>
          <div>
            <SelectBox
              mastCd="ITEM_PRD_CD"
              id="subItemPrdCd3"
              name="subItemPrdCd3"
              disabled={isFieldDisabled(state, "subItemPrdCd3", disabledFields)}
              topSelected="선택"
              onChange={handleChangeField}
              attr1={fieldValues.subItemCd3}
              value={fieldValues.subItemPrdCd3}
              className="ip2"
            />
          </div>
        </li>
        <li>
          <div>
            <SelectBox
              mastCd="ITEM_RATE"
              id="subItemRate3"
              name="subItemRate3"
              disabled={isFieldDisabled(state, "subItemRate3", disabledFields)}
              topSelected="선택"
              onChange={handleChangeField}
              value={fieldValues.subItemRate3}
              className="ip2"
            />
          </div>
        </li>
      </ul>
      <ul className="mlist">
        <li className="fullhead">
          <div>감량 반품 경고 감가</div>
        </li>

        <li className="head">
          <div>감량</div>
        </li>
        <li>
          <div>
            <SelectBox
              mastCd="OUTAGE_WGHT"
              id="outageWght"
              name="outageWght"
              topSelected="선택"
              disabled={isFieldDisabled(state, "outageWght", disabledFields)}
              onChange={handleChangeField}
              value={fieldValues.outageWght}
              className="ip2"
            />
          </div>
        </li>
        <li>
          <div>
            <SelectBox
              mastCd="OUTAGE_CD"
              id="outageRsn"
              name="outageRsn"
              topSelected="선택"
              disabled={isFieldDisabled(state, "outageRsn", disabledFields)}
              onChange={handleChangeField}
              value={fieldValues.outageRsn}
              className="ip2"
            />
          </div>
        </li>

        <li className="head">
          <div>반품/경고</div>
        </li>
        <li>
          <div>
            <SelectBox
              mastCd="RETURN_CD"
              id="returnCd"
              name="returnCd"
              topSelected="선택"
              disabled={isFieldDisabled(state, "returnCd", disabledFields)}
              onChange={handleChangeField}
              value={fieldValues.returnCd}
              className="ip2"
            />
          </div>
        </li>
        <li>
          <div>
            <SelectBox
              mastCd="OUTAGE_CD"
              id="returnRsn"
              name="returnRsn"
              topSelected="선택"
              disabled={isFieldDisabled(state, "returnRsn", disabledFields)}
              onChange={handleChangeField}
              value={fieldValues.returnRsn}
              className="ip2"
            />
          </div>
        </li>

        <li className="head">
          <div>감가</div>
        </li>
        <li>
          <div>
            <SelectBox
              mastCd="ITEM_RATE"
              id="dprctRate"
              name="dprctRate"
              disabled={
                fieldValues.systemCd === "DH"
                  ? true
                  : isFieldDisabled(state, "dprctRate", disabledFields)
              }
              topSelected="선택"
              onChange={handleChangeField}
              value={fieldValues.dprctRate}
              className="ip2"
            />
          </div>
        </li>
        <li>
          <div>
            <SelectBox
              mastCd="DPRCT_CD"
              id="dprctCd"
              name="dprctCd"
              topSelected="선택"
              disabled={
                fieldValues.systemCd === "DH"
                  ? true
                  : isFieldDisabled(state, "dprctCd", disabledFields)
              }
              onChange={handleChangeField}
              value={fieldValues.dprctCd}
              className="ip2"
            />
          </div>
        </li>
      </ul>

      <Modal.Footer>
        <button className="btn btn-primary" onClick={handleMasterSave}>
          {inspData.inspNo === "" || inspData.inspNo === null
            ? "등급입력"
            : "등급수정"}
        </button>
        {/*
        <button className="btn btn-info" onClick={handleInspectionAI}>
          AI 검수시작
        </button> */}
      </Modal.Footer>
    </>
  );
};

export default Grade;
